import { Box, CircularProgress } from "@getsoren/design-system";

const PageLoading = () => (
  <Box height="100%" display="flex" alignItems="center" justifyContent="center">
    <CircularProgress />
  </Box>
);

export default PageLoading;
